export default "__VITE_ASSET__CJ21iA$h__"